var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerUserCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3352_2527",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3352_2527)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.0013 29.3337C14.1569 29.3337 12.4235 28.9837 10.8013 28.2837C9.17908 27.5837 7.76797 26.6337 6.56797 25.4337C5.36797 24.2337 4.41797 22.8226 3.71797 21.2003C3.01797 19.5781 2.66797 17.8448 2.66797 16.0003C2.66797 14.1559 3.01797 12.4225 3.71797 10.8003C4.41797 9.1781 5.36797 7.76699 6.56797 6.56699C7.76797 5.36699 9.17908 4.41699 10.8013 3.71699C12.4235 3.01699 14.1569 2.66699 16.0013 2.66699C17.8457 2.66699 19.5791 3.01699 21.2013 3.71699C22.8235 4.41699 24.2346 5.36699 25.4346 6.56699C26.6346 7.76699 27.5846 9.1781 28.2846 10.8003C28.9846 12.4225 29.3346 14.1559 29.3346 16.0003C29.3346 17.8448 28.9846 19.5781 28.2846 21.2003C27.5846 22.8226 26.6346 24.2337 25.4346 25.4337C24.2346 26.6337 22.8235 27.5837 21.2013 28.2837C19.5791 28.9837 17.8457 29.3337 16.0013 29.3337Z",
    fill: "#5F6376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0065 17.7339L13.1037 20.6301C12.8712 20.8626 12.5804 20.9799 12.2313 20.9821C11.882 20.9843 11.5889 20.867 11.352 20.6301C11.1196 20.3977 11.0033 20.1057 11.0033 19.7542C11.0033 19.4028 11.1196 19.1109 11.352 18.8785L14.2482 15.9756L11.352 13.1003C11.1196 12.8679 11.0022 12.5771 11 12.2279C10.9978 11.8786 11.1152 11.5855 11.352 11.3487C11.5845 11.1162 11.8765 11 12.228 11C12.5793 11 12.8712 11.1162 13.1037 11.3487L16.0065 14.2449L18.8818 11.3487C19.1143 11.1162 19.4062 11 19.7575 11C20.109 11 20.401 11.1162 20.6335 11.3487C20.88 11.5951 21.0033 11.8906 21.0033 12.2351C21.0033 12.5795 20.88 12.8679 20.6335 13.1003L17.7372 15.9756L20.6335 18.8785C20.8659 19.1109 20.9821 19.4028 20.9821 19.7542C20.9821 20.1057 20.8659 20.3977 20.6335 20.6301C20.3871 20.8767 20.0916 21 19.747 21C19.4027 21 19.1143 20.8767 18.8818 20.6301L16.0065 17.7339Z",
    fill: "#454746"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerUserCross);
export default __webpack_public_path__ + "static/media/powerUserCross.1bdf6ee267a28a8f05ff008b049996c8.svg";
export { ForwardRef as ReactComponent };